<script lang="ts">
    import {dyData, modal} from 'general/store';
    import {TEMPLATE} from 'general/constants';

    import Description from 'general/components/description/Description.svelte';
    import RoundCheckIcon from 'desktop/icons/RoundCheckLarge.svelte';
    import DyButton from 'general/components/dyButton/DyButton.svelte';
    import ShopConditions from 'desktop/components/shopConditions/ShopConditions.svelte';
    import ScrollItem from 'general/components/scrollItem/ScrollItem.svelte';

    import s from './style.module.css';
</script>

<ScrollItem>
    <div class={s.main} style="margin-top: {$dyData.side.subscribed?.marginTop || 0}">
        <div class={s.checkIcon}>
            <RoundCheckIcon size={68} color="#00995C" />
        </div>
        <Description template={TEMPLATE.EXP_SQUARE} value={$dyData.description?.subscribed} />

        <ShopConditions />

        <div class={s.button}>
            <DyButton
                type="button"
                children="Continue Shopping"
                onClick={modal.close}
                size="medium"
                color="blue"
                rounded={true}
                marginTop="28px"
                {...$dyData.mainButton?.subscribed || {}}
            />
        </div>
    </div>
</ScrollItem>
